module.exports = __webpack_public_path__ + "static/media/bytt-nn-19.c3fd15be.mp3";